import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FilterDropdown } from 'views/rebranded-module/common/components/UI/FilterDropdown';

const StyledBox = styled(Box)(({ theme }) => ({

  '& .EFSContent': {
    position: 'relative',
    zIndex: 2,
    marginBottom: theme.typography.pxToRem(112),
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.typography.pxToRem(40),
    },
  },
  '& .EFSFiltersContainer': {
    display: 'flex',
    border: `1px solid ${theme.palette.divider[7]}`,
    width: 'fit-content',
    borderRadius: theme.spacing(0.5),
    background: theme.palette.secondary.main,
    backdropFilter: `blur(${theme.spacing(1)})`,
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    '& .EFSEventInput': {
      minWidth: theme.typography.pxToRem(164),
      [theme.breakpoints.down('md')]: {
        width: '50%',
        minWidth: 'unset',
      },
    },
  },
  '& .EFSCardBox':{
    width: '100%',
    height:'100%',

  },
}));
export const StyledFilterDropdown = styled(FilterDropdown)(({ theme }) => ({
  '& .FDSelectInput': {
    width: '100%',
    [theme.breakpoints.down('lg')]: {
      border: '0 !important',
      borderRadius: '0 !important',
      borderRight: `1px solid ${theme.palette.divider[7]}  !important`,
    },
    '& .MuiSelect-select': {
      padding: `${theme.spacing(2.25, 3, 1.75, 6)}  !important`,
    },
  },
  '& .MuiList-root': {
    background: 'red',
  },
  '&.FDLastDropdown': {
    '& .FDSelectInput': {
      [theme.breakpoints.down('md')]: {
        borderRight: '0 !important',
      },
    },
  },
}));
export default StyledBox;
